import Discount from "./discount";
import MinMax from "./min-max";
import Additional from "./additional";
import Custom from "./custom";
import Payment from "./payment";
import Webhook from "./webhook";
import PriceDiscount from "./price-discount";
import Main from "./main";
import VariantInfo from "./variant-info";
import Market from "./market";
import Product from "./product";
import Pricing from "./price";
import Discord from "./discord";
import Telegram from "./telegram";
import Variants from "./variants";

export {
	Product,
	Pricing,
	Discount,
	Custom,
	Webhook,
	VariantInfo,
	PriceDiscount,
	MinMax,
	Additional,
	Payment,
	Main,
	Market,
	Discord,
	Telegram,
	Variants,
}